// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XHStack_XHStack__khYbN {
  border: 0px none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/X/styles/XHStack.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".XHStack {\n    border: 0px none;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XHStack": `XHStack_XHStack__khYbN`
};
export default ___CSS_LOADER_EXPORT___;
